module.exports = __webpack_public_path__ + "images/application/auth-locks-b2b60ba3.svg";